import { BrainCircuit } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { SheetClose, SheetTitle } from '@/components/ui/sheet';

export function EmoviDocPanelHeader() {
  return (
    <div className="h-14 shrink-0 border-b border-border px-4 flex items-center justify-between">
      <div className="flex items-center gap-2">
        <BrainCircuit className="h-4 w-4 text-primary" aria-hidden />
        <SheetTitle className="text-sm">EmoviDoc</SheetTitle>
      </div>
      <SheetClose asChild>
        <Button type="button" variant="ghost" size="sm">
          Chiudi
        </Button>
      </SheetClose>
    </div>
  );
}
